
















































































































import { defineComponent, reactive, toRefs, PropType, computed, ref, onMounted, onBeforeUnmount, watch } from '@vue/composition-api';
import { BModal } from 'bootstrap-vue';
import * as Common from "../commons/common"
import AlertArea from "../components/AlertArea.vue";
import http from "../plugins/http";
// @ts-ignore
import VueDragResize from "vue-drag-resize";
import { SheetActivity, Examinee, SheetActivityHoseiPosition, SheetField } from "../modules/teacher/SheetUpload"


export interface Data {
  headerHeight: number
  footerHeight: number
  inputScale: number
  imageMargin: number
  stickSize: number
  aspectRatio: boolean
  isActive: boolean
  targetType: number
  errors: any[]
  fields: any[]
  isAllChecked: boolean
  executeType: number
  imageRetryCount: number
  imageRetryTimer: number | null
  isImageFallbackLoading: boolean
  isImageFallbackExecuted: boolean
}

export default defineComponent({
  components: {
    "vue-drag-resize": VueDragResize,
    "alert-area": AlertArea,
  },
  props: {
    visible: {
      type: Boolean as PropType<boolean>,
      required: true
    },
    windowHeight: {
      type: Number as PropType<number>,
      required: true
    },
    sheetId: {
      type: String as PropType<string>,
      required: true
    },
    currentExamineeIdx: {
      type: Number as PropType<number>,
      required: true
    },
    currentSheetActivityIdx: {
      type: Number as PropType<number>,
      required: true
    },
    examinees: {
      type: Array as PropType<Examinee[]>,
      required: true
    },
    sheetFields: {
      type: Array as PropType<SheetField[]>,
      required: true
    },
    correctImageWidth: {
      type: Number as PropType<number>,
      required: true
    },
    correctImageHeight: {
      type: Number as PropType<number>,
      required: true
    },
    pageCount: {
      type: Number as PropType<number>,
      required: true
    },
    is_exists_backup_image: {
      type: Boolean as PropType<boolean>,
      required: true
    },
  },
  setup (props, context) {

    const SheetTypeEnum = Common.SheetTypeEnum;
    enum TargetTypeEnum {All = 1, Only = 2, Select = 3};
    enum ExecuteTypeEnum {Execute = 1, Reset = 2};


    const modalSelectTargetRef = ref<InstanceType<typeof BModal>>();

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      headerHeight: 45,
      footerHeight: 50,
      inputScale: 50,
      imageMargin: 100,
      stickSize: context.root.$store.state.isMobile ? 32 : 12,
      aspectRatio: false,
      isActive: false,
      targetType: 1,
      errors: [],
      fields: [],
      isAllChecked: false,
      executeType: null,
      imageRetryCount: 0,
      imageRetryTimer: null,
      isImageFallbackLoading: false,
      isImageFallbackExecuted: false,
    });

    /************************************************************
     * 表示対象のexaminee
     ************************************************************/

     const currentExaminee = computed(() => {
      return props.currentExamineeIdx == null ? null : props.examinees[props.currentExamineeIdx];
    });

    /************************************************************
     * 答案アップロードされているexaminee
     ************************************************************/

    const uploadedExaminees = computed((): Examinee[] => {
      return props.examinees.filter((x: Examinee) => x.sheetActivities.length > 0);
    });

    /************************************************************
     * バックアップ画像が存在するexaminee
     ************************************************************/

    const backupedExaminees = computed((): Examinee[] => {
      return uploadedExaminees.value.filter(x => x.sheetActivities.filter(y => y.is_exists_backup_image).length > 0);
    });

    /************************************************************
     * 生徒選択モーダルに非表示するexaminee
     ************************************************************/

     const modalTargetExaminees = computed((): Examinee[] => {
      return state.executeType == ExecuteTypeEnum.Reset ? backupedExaminees.value : uploadedExaminees.value;
    });

    /************************************************************
     * 表示対象のsheetActivity
     ************************************************************/

    const currentSheetActivity = computed(() => {
      return currentExaminee.value && currentExaminee.value.sheetActivities.length >= props.currentSheetActivityIdx + 1 ? currentExaminee.value.sheetActivities[props.currentSheetActivityIdx] : null;
    });

    /************************************************************
     * 表示対象のsheetFields
     ************************************************************/

    const currentSheetFields = computed(() => {
      return props.sheetFields && props.sheetFields.length >= 0 ? props.sheetFields.filter(x => x.page == props.currentSheetActivityIdx + 1) : [];
    });

    /************************************************************
     * 次の生徒 or 前の生徒ボタン押下
     ************************************************************/

    const changeExaminee = (addCount: number) => {
      const currentExamineeIdx = uploadedExaminees.value.indexOf(currentExaminee.value) + addCount;
      if(currentExamineeIdx < 0 || currentExamineeIdx >= uploadedExaminees.value.length){
        return;
      }
      context.emit("change-current", uploadedExaminees.value[currentExamineeIdx], props.currentSheetActivityIdx);
    }

    /************************************************************
     * 画像領域の高さ
     ************************************************************/

    const scale = computed((): number => {
      return state.inputScale / 100;
    });

    /************************************************************
     * 画像領域の高さ
     ************************************************************/

    const imageAreaHeight = computed((): number => {
      return props.windowHeight - state.headerHeight - state.footerHeight;
    });

    /************************************************************
     * 画像の親DivのCSSスタイル
     ************************************************************/

    const imageWrapStyle = computed((): any => {
      let style: any = {};
      const sheetActivitiy: SheetActivity | null = currentSheetActivity.value;
      if(sheetActivitiy != null){
        style["width"] = `${(sheetActivitiy.baseWidth + (state.imageMargin * 2)) * scale.value}px`;
        style["height"] = `${(sheetActivitiy.baseHeight + (state.imageMargin * 2)) * scale.value}px`;
      }
      
      return style;
    });

    /************************************************************
     * 画像の親DivのCSSスタイル
     ************************************************************/

    const correctImageGuideStyle = computed((): any => {
      let style: any = {};
      const sheetActivitiy: SheetActivity | null = currentSheetActivity.value;
      if(sheetActivitiy != null){
        style["width"] = `${props.correctImageWidth * scale.value}px`;
        style["height"] = `${props.correctImageHeight * scale.value}px`;
        style["left"] = `${state.imageMargin * scale.value}px`;
        style["top"] = `${state.imageMargin * scale.value}px`;
      }
      
      return style;
    });

    const imageMousedown = () => {
      state.aspectRatio = true;
    }

    /************************************************************
     * サイドバー画像のリトライ状態を初期化する
     ************************************************************/
    const resetImageLoadState = () => {
      state.imageRetryCount = 0;
      state.isImageFallbackLoading = false;
      state.isImageFallbackExecuted = false;
      if(state.imageRetryTimer != null){
        clearTimeout(state.imageRetryTimer);
        state.imageRetryTimer = null;
      }
    }

    /************************************************************
     * 短い遅延を入れて同一URLを再セットし、画像再取得を試みる
     ************************************************************/
    const setRetryImageSrc = () => {
      if(!currentSheetActivity.value || !currentSheetActivity.value.imageUrl){
        return;
      }
      state.imageRetryCount++;
      currentSheetActivity.value.imageSrc = null;
      if(state.imageRetryTimer != null){
        clearTimeout(state.imageRetryTimer);
      }
      state.imageRetryTimer = window.setTimeout(() => {
        currentSheetActivity.value.imageSrc = currentSheetActivity.value.imageUrl;
      }, 200);
    }

    /************************************************************
     * 最終手段としてサーバー経由でBase64画像を取得し、表示ソースを差し替える
     ************************************************************/
    const setFallbackImageSrc = async () => {
      if(!currentSheetActivity.value){
        return;
      }
      if(state.isImageFallbackLoading || state.isImageFallbackExecuted){
        return;
      }
      state.isImageFallbackLoading = true;
      try{
        const response = await http.get(`/api/teacher/sheet_upload/download_base64_image/${props.sheetId}/${currentSheetActivity.value.id}`);
        currentSheetActivity.value.imageSrc = `data:image/jpeg;base64,${response.data.base64_image}`;
        const size = await Common.getImageSizeFromBase64DataUrl(currentSheetActivity.value.imageSrc);
        currentSheetActivity.value.baseWidth = size.width;
        currentSheetActivity.value.baseWidthCache = size.width;
        currentSheetActivity.value.baseHeight = size.height;
        currentSheetActivity.value.baseHeightCache = size.height;
        state.isImageFallbackExecuted = true;
      }catch(error){
        console.error(error);
      }finally{
        state.isImageFallbackLoading = false;
      }
    }

    /************************************************************
     * 画像読込エラー時: 2回までは再試行、それでも失敗した場合はBase64フォールバック
     ************************************************************/
    const hoseiImageError = async () => {
      if(state.imageRetryCount < 2){
        setRetryImageSrc();
        return;
      }
      await setFallbackImageSrc();
    }

    /************************************************************
     * サイドバーClose
     ************************************************************/

    const hiddenSidebar = () => {
      context.emit("hidden");
    }

    /************************************************************
     * 拡大縮小
     ************************************************************/

    const inputScaleChanged = (event: number) => {
      state.aspectRatio = false;
      state.inputScale = event
    }

    /************************************************************
     * 画像スタンプドラッグ終了
     ************************************************************/

    const imageDragStop = (rect: any) => {
      currentSheetActivity.value.x = (rect.left / scale.value) - state.imageMargin;
      currentSheetActivity.value.y = (rect.top / scale.value) - state.imageMargin;
    }

    /****************************************
     * 画像スタンプリサイズ終了
     ****************************************/
    
    const imageResizeStop = (rect: any) => {
      context.root.$nextTick(() => {
        currentSheetActivity.value.x = (rect.left / scale.value) - state.imageMargin;
        currentSheetActivity.value.y = (rect.top / scale.value) - state.imageMargin;
        currentSheetActivity.value.baseWidth = rect.width / scale.value;
        currentSheetActivity.value.baseHeight = rect.height / scale.value;
      });
    };

    /****************************************
     * 生徒選択モーダル表示
     ****************************************/

    const showTargetModal = (executeType: number) => {
      uploadedExaminees.value.forEach(x => x.isHoseiTarget = false);
      state.targetType = TargetTypeEnum.All;
      state.executeType = executeType;
      modalSelectTargetRef.value.show();
    }

    /****************************************
     * 生徒選択テーブル全件選択
     ****************************************/

    const allSelectChanged = (isChecked: boolean) => {
      if(state.executeType == ExecuteTypeEnum.Execute){
        uploadedExaminees.value.forEach(x => x.isHoseiTarget = isChecked);
      }else{
        backupedExaminees.value.forEach(x => x.isHoseiTarget = isChecked);
      }
      
    }

    /****************************************
     * 補正実行
     ****************************************/

    const hoseiExecute = () => {

      const sheetActivities = currentExaminee.value.sheetActivities.filter(x => x.x != 0 || x.y != 0 || x.baseWidth != x.baseWidthCache || x.baseHeight != x.baseHeightCache);

      if(sheetActivities.length == 0){
        alert("変更されたページがありません。");
        return;
      }

      if(state.targetType == TargetTypeEnum.Select && uploadedExaminees.value.filter(x => x.isHoseiTarget).length == 0){
        alert("対象の生徒が選択されていません。");
        return;
      }

      const pageItems: any[] = [];

      sheetActivities.forEach(x => {
        const page = x.page;
        const sheetActivityIds = [];
        if(state.targetType == TargetTypeEnum.All){
          uploadedExaminees.value.forEach(y => {
            const sheetActivityId = y.sheetActivities.find(z => z.page == page).id;
            if(sheetActivityId){
              sheetActivityIds.push(sheetActivityId);
            }
          });
        }else if(state.targetType == TargetTypeEnum.Only){
          sheetActivityIds.push(x.id);
        }else{
          uploadedExaminees.value.filter(y => y.isHoseiTarget).forEach(y => {
            const sheetActivityId = y.sheetActivities.find(z => z.page == page).id;
            if(sheetActivityId){
              sheetActivityIds.push(sheetActivityId);
            }
          });
        }

        const pageItem = {
          page: page,
          x_shift: x.x,
          y_shift: x.y,
          scale: x.baseWidth / x.baseWidthCache,
          sheet_activity_ids: sheetActivityIds,
        }

        console.log(pageItem)

        pageItems.push(pageItem);
      });

      if(!window.confirm(`答案用紙を補正します。よろしいですか？`)){
        return;
      }

      hiddenSidebar();
      modalSelectTargetRef.value.hide();

      context.emit("adjust-image-shift", pageItems);
    }


    /****************************************
     * 補正リセット スキャン時点の画像に戻す
     ****************************************/

    const resetAdjustImageShift = () => {
      
      if(state.targetType == TargetTypeEnum.Select && uploadedExaminees.value.filter(x => x.isHoseiTarget).length == 0){
        alert("対象の生徒が選択されていません。");
        return;
      }
      
      if(!window.confirm(`答案用紙をアップロード時点の状態にリセットします。よろしいですか？`)){
        return;
      }

      let examineeIds: number[] = [];

      if(state.targetType == TargetTypeEnum.All){
        examineeIds = uploadedExaminees.value.map(x => x.id);
      }else if(state.targetType == TargetTypeEnum.Only){
        examineeIds.push(currentExaminee.value.id);
      }else{
        examineeIds = uploadedExaminees.value.filter(x => x.isHoseiTarget).map(x => x.id);
      }

      hiddenSidebar();
      modalSelectTargetRef.value.hide();

      context.emit("reset-adjust-image-shift", examineeIds);
    }
    
    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {

      state.fields.push({key: "isHoseiTarget", label: "選択", class: 'text-center', thStyle: {width: "80px"}});
      if(!context.root.$store.getters.isEntranceOrPractice){
        state.fields.push({key: "student_no", label: "番号", sortable: true, class: 'text-center b-table-th-td'});        
      }
      const characterName = context.root.$store.getters.isEntranceOrPractice ? "受験番号" : "学籍番号"
      state.fields.push({key: "student_no_character", label: characterName, sortable: true, class: 'text-center b-table-th-td'});
      state.fields.push({key: "student_name", label: "氏名", sortable: true, class: 'text-center b-table-th-td'});
      state.fields.push({key: "uploaded_at", label: "アップロード日時", sortable: true, class: 'text-center b-table-th-td'});
    });

    onBeforeUnmount(async () => {
      if(state.imageRetryTimer != null){
        clearTimeout(state.imageRetryTimer);
        state.imageRetryTimer = null;
      }
    });

    watch(() => currentSheetActivity.value?.id, (newVal, oldVal) => {
      resetImageLoadState();
      if(currentSheetActivity.value && currentSheetActivity.value.imageUrl && !currentSheetActivity.value.imageSrc){
        currentSheetActivity.value.imageSrc = currentSheetActivity.value.imageUrl;
      }
    });

    return {
      ...toRefs(state),
      SheetTypeEnum,
      TargetTypeEnum,
      ExecuteTypeEnum,
      modalSelectTargetRef,
      currentSheetActivity,
      currentSheetFields,
      scale,
      imageAreaHeight,
      imageWrapStyle,
      correctImageGuideStyle,
      currentExaminee,
      uploadedExaminees,
      backupedExaminees,
      modalTargetExaminees,
      hiddenSidebar,
      imageDragStop,
      imageResizeStop,
      imageMousedown,
      hoseiImageError,
      inputScaleChanged,
      hoseiExecute,
      resetAdjustImageShift,
      changeExaminee,
      allSelectChanged,
      showTargetModal,
    }
  }
});
